import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaLibraryComponent } from './sa-library.component';
import { MatIconModule } from '@angular/material/icon';
import { SaLibraryRoutingModule } from './sa-library-routing.module';
import { DocumentSearchResultsComponent } from './document-search-results/document-search-results.component';
import { DocumentSearchResultCardComponent } from './document-search-result-card/document-search-result-card.component';
import { DocumentDetailsComponent } from './document-details/document-details.component';
import { ControlsModule } from '../controls/controls.module';
import { DocumentTypeBadgeComponent } from './document-type-badge/document-type-badge.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveFormsModule } from '@angular/forms';
import { DocumentDetailsOverviewComponent } from './document-details/document-details-overview/document-details-overview.component';
import { SIMPublicationStatusBadgeComponent } from '../projects/shared/components/sim-publication-status-badge/sim-publication-status-badge.component';
import { DocumentDetailsValuesComponent } from './document-details/document-details-values/document-details-values.component';
import { DocumentDetailsKeyDatesComponent } from './document-details/document-details-key-dates/document-details-key-dates.component';
import { SaLibraryDownloadComponent } from './shared/components/sa-library-download/sa-library-download.component';

@NgModule({
  declarations: [
    SaLibraryComponent,
    DocumentSearchResultsComponent,
    DocumentSearchResultCardComponent,
    DocumentDetailsComponent,
    DocumentTypeBadgeComponent,
    DocumentDetailsOverviewComponent,
    SIMPublicationStatusBadgeComponent,
    DocumentDetailsValuesComponent,
    DocumentDetailsKeyDatesComponent,
    SaLibraryDownloadComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    FontAwesomeModule,
    SaLibraryRoutingModule,
    ControlsModule,
    ReactiveFormsModule
  ]
})
export class SaLibraryModule { }
